<script setup>

const props = defineProps({

  modelValue: {},

})

function selectItem(item) {

  clearSelected('skuNames');

  if(props.modelValue.skuComposites.length > 0) clearSelected('skuComposites');

  props.modelValue.skuComposites = item.skuComposites;
  props.modelValue.selectedSkuName = item.skuName;

  item.active = !item.active;

}

function clearSelected(model) {

  props.modelValue[model].forEach(item => {

    item.active = false;

  });

  props.modelValue.selectedSkuComposite = '';
  props.modelValue.skuCompositeGridData = [];

}

</script>

<template>
  <div class="cmp-sku-history-name-group-list_wrapper">
    <div v-for="item in props.modelValue.skuNames">
      <div @click="selectItem(item)" class="cmp-sku-history-name-group-list_list-items" :title="item.skuName"
           :class="{'cmp-sku-history-name-group-list_active' : item.active}"><span>{{item.skuName}}</span>
        <i class="fa-duotone fa-circle-arrow-right cmp-sku-history-name-group-list_name-icon"></i>
      </div>
    </div>
    <div v-if="props.modelValue.skuNames.length === 0"
         class="cmp-sku-history-name-group-list_no-data">
      <i class="fa-duotone fa-triangle-exclamation" style="margin-right: 4px; color: #d51b1b"></i>No Data Found</div>
  </div>
</template>

<style lang="scss" scoped>

span {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.cmp-sku-history-name-group-list {

  &_wrapper {
    height: 585px;
    overflow-y: scroll;
    margin-top: 12px;
  }

  &_wrapper &_list-items {
    padding: 3px 0 3px 5px;
    border-top: 1px solid #efefef;
    border-bottom: 1px solid #efefef;
    font-size: 11px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: -1px;
    height: 14px;
    color: #313131;
  }

  &_wrapper div:nth-child(even) {
    background-color: #fafafa;
  }

  &_wrapper &_list-items:hover {
    background-color: #eeeeee;
  }

  &_name-icon {
    visibility: hidden;
    color: #0e934b;
    margin-right: 5px;
    font-size: 14px;
  }

  &_active {
    font-weight: bold;
    background-color: #fff8e8;
  }

  &_active &_name-icon {
    visibility: visible;
  }

  &_no-data {
    font-size: 13px;
    display: flex;
    justify-content: center;
  }

  @media screen and (max-width: 1679px) {

    &_wrapper {
      height: 145px;
      overflow-y: scroll;
      max-width: 540px;
    }

  }

}

</style>
